/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-sequences */
import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Background from "../../utility-components/Background"
import Button from "../../utility-components/Button";
import TransparentButton from "../../utility-components/TransparentButton";
import EndGamePopUp from '../../utility-components/EndGamePopUp';

import Scores from '../../planet-preop/scoreData.json';
import { submitGameboardScore } from "../../../../../actions/game";

const Comet = ({closeModal, user}) => {
  const maxScores = Scores.winterScores;
  const dispatch = useDispatch();
  const [stage, setStage] = useState(-2);
  const history = useHistory();
  const [isComplete, setIsComplete] = useState(false);
  const [currentType, setCurrentType] = useState('');
  const [currentPhraseTypes, setCurrentPhraseTypes] = useState([]);
  const [startIndex, setStartIndex] = useState(-1);
  const [endIndex, setEndIndex] = useState(-1);
  const [wordBank, setWordBank] = useState([]);
  const [isCompleteThree, setIsCompleteThree] = useState(false);
  const [currentPoints, setCurrentPoints] = useState(0);
  const [currentList, setCurrentList] = useState([]);
  const [currentLists, setCurrentLists] = useState([]);
  const [correctAmount, setCorrectAmount] = useState(-1);
  const [progress, setProgress] = useState([0, 0, 0]);
  const [tries, setTries] = useState([0, 0, 0]);
  const correctOneAnswers = [0, 6, 14, 65, 74, 109, 116, 125, 147,
                             170, 171, 173, 185, 191, 193, 196, 204,
                             216, 222, 241, 242, 248, 258, 287, 296,
                             303, 309, 323, 330, 336, 346, 360, 377]; //
  const correctTwoAnswers = [
    {
      type: "assertion",
      sIndex: 0,
      eIndex: 6
    },
    {
      type: "supportive",
      sIndex: 7,
      eIndex: 27,
    },
    {
      type: "supportive",
      sIndex: 194,
      eIndex: 199,
    },
    {
      type: "supportive",
      sIndex: 295,
      eIndex: 301,
    },
    {
      type: "conclusion",
      sIndex: 375,
      eIndex: 383,
    }
  ];
  const correctThreeAnswers = [
    [4, 5, 6],
    [2, 3, 5],
    [1, 3, 4]
  ]
  const activityName = 'comet-mission';
  const bParagraph = `\tGratitude is the key to personal joy. First, when we take a moment to appreciate even the smallest of things in our lives, we improve our overall mood. In general, it's not our life circumstances that create our emotions, it's our thoughts about these circumstances that determine our feelings. In short, our thoughts create our mood. Therefore, when we find ourselves in a stressful or negative situation, if we pause to focus on something positive, even the smallest of things - a warm cup of tea, a window to gaze through, a sturdy chair to sit in - we then activate the parts of our brain that bring us pleasure. One scientific study has revealed that gratitude "releases dopamine (a neurotransmitter related to feelings of pleasure and reward - motivated behavior) and serotonin (a neurotransmitter believed to help regulate mood and social behavior); in other words, feeling grateful for anything, be it large or small, makes us feel better" (qtd. in Guerra). So, the next time we find ourselves feeling sullen, grumpy, or agitated, if we take a deep breath and think about something we appreciate, we will promote feelings of happiness and vitality. In addition, thankfulness shrinks our problems. Filling our hearts with appreciation, we view our life circumstances differently. This new focus enables the positives to grow within our heart's perspective, naturally crowding out any feelings of lack. We feel more abundant and less deprived. It's as if the gratitude hoists us upward so that we perceive our problems from a distance. From this point of elevation, our dilemmas are smaller. This does not mean our problems are unimportant, but it does mean they look less vicious, less likely to conquer us. We regain our optimistic view of the challenge. Hope is renewed. Lastly, grateful people have happier, healthier relationships.  Viewing others through the lens of gratitude, we see the good in those we call family, friends, or colleagues. We recognize their contributions. Minor flaws are less agitating. Small blunders or opposing perspectives irritate less. As a result, we, ourselves, are more likable. Cherishing the good in people, we radiate respect, enabling others to trust us. When gratitude is our life's cornerstone, we can build sturdy friendships able to withstand stormy conditions. Be assured, joyful living grows from the inside out.`;
  const cometPdfProp = {
    width: '315px',
    height: '25px',
    top: '228px',
    left: '541px',
    zIndex: '22300'
  }
  const paragraphProp = {
    width: '210px',
    height: '37px',
    top: '28px',
    left: '53px',
    zIndex: '22300'
  }
  const wordBankProp = {
    width: '66px',
    height: '87px',
    top: '34px',
    left: '939px',
    zIndex: '22300'
  }
  const paragraphDProp = {
    width: '150px',
    height: '66px',
    top: '67px',
    left: '870px',
    zIndex: '22300'
  }
  const questionDProp = {
    width: '124px',
    height: '71px',
    top: '48px',
    left: '74px',
    zIndex: '22300'
  }

  const setToCurrentProgress = () => {
    let prevProgIndex;
    if (user?.result.type === 'student') {
      prevProgIndex = user?.result.gameboardStats ? user?.result.gameboardStats.missionProgress.findIndex((mission) => mission.name === activityName) : -1
    } else {
      prevProgIndex = -1;
    }
    let missionProgress = prevProgIndex >= 0 ? user?.result.gameboardStats.missionProgress[prevProgIndex].progressTypeSix : null;
    //setCurrentPoints(missionProgress !== null ? missionProgress.progressTypeSix.currentPoints : 0);
    setStage(missionProgress !== null ? missionProgress.currentStage : -1);
    setWordBank(missionProgress !== null && missionProgress.currentStage === 0 ? missionProgress.currentNumList : []);
    setCurrentPhraseTypes(missionProgress !== null && missionProgress.currentStage === 1 ? missionProgress.currentStringProgress : []);
    setCurrentLists(missionProgress !== null && (missionProgress.currentStage >= 2 && missionProgress.currentStage <= 4 ? missionProgress.numAnswer : []))
    setProgress(missionProgress !== null ? missionProgress.progress : [0, 0, 0]);
  }

  const compareAnswersOne = () => {
    const newProgress = [...progress];
    const newTries = [...tries];
    let corAmt = 0;
    for (let i = 0; i < wordBank.length; i++) {
      if (correctOneAnswers.includes(wordBank[i])) {
        corAmt += 1;
      }
    }
    let curScore = Math.round((corAmt / correctOneAnswers.length) * 100) // 30 is the length
    newTries[0] = newTries[0] + 1;
    newProgress[0] = curScore + (corAmt === 30 && tries[0] <= 1 ? 10: 0);
    submitScore(newProgress[0], activityName, [], newProgress, newTries, stage, 'numList', false);
    setTries(newTries);
    setProgress(newProgress);
    setCorrectAmount(corAmt);
  }

  const compareAnswersTwo = () => {
    const newProgress = [...progress];
    const newTries = [...tries];
    const currentCorrectType = correctTwoAnswers;
    let correctAmount = 0;
    for (let i = 0; i < currentCorrectType.length; i++) {
      for (let j = currentCorrectType[i].sIndex; j <= currentCorrectType[i].eIndex; j++) {
        if (j === currentCorrectType[i].sIndex) {
          if (currentPhraseTypes[j] !== currentCorrectType[i].type.concat('Start')) {
            break;
          }
        } else {
          if (currentPhraseTypes[j] !== currentCorrectType[i].type) {
            break;
          }
        }
        if (j === currentCorrectType[i].eIndex) {
          correctAmount += 1;
        }
      }
    }
    let newScore = correctAmount * 20;
    newTries[1] = newTries[1] + 1;
    newProgress[1] = newScore > newProgress[1] ? newScore + (tries[1] <= 1 && correctAmount === 5 ? 20 : 0) : newProgress[1];
    submitScore(newProgress[1], activityName, [], newProgress, newTries, stage, 'stringList', false);
    setProgress(newProgress);
    setTries(newTries);
    setCorrectAmount(correctAmount);
  }

  const compareAnswersThree = () => {
    const newTries = [...tries];
    const newProgress = [...progress];
    let corAmt = 0;
    for (let i = 0; i < 3; i++){
      for (let j = 0; j < 3; j++) {
        if (currentLists[i][j] === correctThreeAnswers[i][j]) {
          corAmt += 1;
        }
      }
    }
    let newScore = corAmt * 10;
    newTries[2] = newTries[2] + 1;
    newProgress[2] = newScore > newProgress[2] ? newScore + (newTries[2] <= 1 && corAmt === 9 ? 10 : 0) : newProgress[2];
    submitScore(newProgress[2], activityName, [], newProgress, newTries, 2, 'num', false);
    setCorrectAmount(corAmt);
    setProgress(newProgress);
    setTries(newTries);
  }

  const submitScore = async (score, name, curAnswer, curProgress, curTries, curStage, ansType, isSaveAndExit) => {
    if (user?.result.type !== 'student') {
      return;
    }
    const userDataIndex = user?.result.gameboardStats.missionProgress.findIndex((mission) => mission.name === name);
    const gameIndex = maxScores.findIndex(score => score.activityName === name);

    if (userDataIndex > 0 && gameIndex >= 0) {
      if (maxScores[gameIndex].maxScore <= user?.result.gameboardStats.missionProgress[userDataIndex].points) {
        return;
      }
    }
    const scoreData = {
      username: user?.result.username,
      missionName: name,
      dollars: score,
      type: 'six',
      currentStage: curStage,
      curNumList: ansType === 'numList' || ansType === 'num' ? curAnswer : [],
      stringLiProgress: ansType === 'stringList' ? curAnswer : [],
      listNumProgress: curProgress,
      tries: curTries,
      answerType: ansType,
      triesType: 'two'
    };
    console.log('submitting score...');

    const result = await dispatch(submitGameboardScore(scoreData));
    if (isSaveAndExit) {
      return result.success;
    }
  }

  const saveAndExit = async () => {
    //const gameName = 'holi-bliss-mission-1';
    let isSave = await submitScore(0, activityName, stage === 0 ? wordBank : stage === 1 ? currentPhraseTypes
                                       : currentLists, progress, tries, stage, stage === 0 ? 'numList' : 
                                       stage === 1 ? 'stringList': 'num', true);

    if (isSave) {
      setIsComplete(true);
    }
    
  }

  const changePhraseTypes = (sIndex, eIndex, curType) => {
    const startPhrase = 'Start';
    let newPhraseTypes = [...currentPhraseTypes];
    eIndex = eIndex < 0 ? sIndex : eIndex;

    for (let i = 0; i < newPhraseTypes.length && i <= eIndex; i++) {
      if ((i >= sIndex && i <= eIndex) && newPhraseTypes[i].length < 1) {
        newPhraseTypes[i] = curType;
        if (i === sIndex) {
          newPhraseTypes[i] = newPhraseTypes[i].concat(startPhrase);
        }
      }
    }
    setCurrentPhraseTypes(newPhraseTypes);
  }

  const deleteIndex = (index) => {
    let newWords = [...wordBank];
    let curWordIndex = newWords.findIndex((ind) => ind === index);
    newWords.splice(curWordIndex, 1);
    setWordBank(newWords);
  }

  const addDetail = (index) => {
    return currentType.length >= 1 && currentPhraseTypes[index].length === 0 ?
    startIndex < 0 ? (setStartIndex(index), setEndIndex(index)) :
    startIndex === index ? endIndex === startIndex ? (setStartIndex(-1), setEndIndex(-1)) : setStartIndex(index + 1) :
    endIndex === index ? endIndex === startIndex ? (setStartIndex(-1), setEndIndex(-1)) : setEndIndex(index - 1) :
    index < startIndex && index >= 0 ? startIndex -1 >= 0 && startIndex - 1 === index ? setStartIndex(index) : (setStartIndex(index), setEndIndex(index)) :
    index > endIndex ? endIndex + 1 < bParagraph.split(" ").length && endIndex + 1 === index ? setEndIndex(index) : (setStartIndex(index), setEndIndex(index)) :
    (setEndIndex(index)) : console.log("Select a valid option first!")
  }

  const getResultScreen = () => {
    const isAlmostTry = (correctAmount < 30 && stage === 0) || (correctAmount < 5 && stage === 1) || (correctAmount < 9 && stage === 4)
    const isCorrectTry = (correctAmount === 30 && stage === 0) || (correctAmount === 5 && stage === 1) || (correctAmount === 9 && stage === 4)
    const isFirstTry = stage === 0 ? tries[0] <= 1 : stage === 1  ? tries[1] <= 1 : tries[2] <= 1

    return `/assets/gameboardPieces/comet/comet-${stage === 4 && correctAmount === 9 ? `stage-${2}-` : (correctAmount === 30 && stage === 0) || (correctAmount === 5 && stage === 1) ? `stage-${stage}-` : ''}${correctAmount === 0 ? 'in': isAlmostTry ? 'almost' : ''}correct-answer${isFirstTry && isCorrectTry ? `-first-try` : ''}.png`
  }

  const addWordToCurrentList = (index) => {
    let newList = [...currentList];
    newList.push(index);
    setCurrentList(newList);
  }

  const deleteWordFromCurrentList = (index) => {
    let newList = [...currentList];
    let curWordIndex = newList.findIndex((ind) => ind === index);
    newList.splice(curWordIndex, 1);
    setCurrentList(newList);
  }

  const addToList = (newList) => {
    let newLists = [...currentLists];
    newLists.push(newList)
    setCurrentLists(newLists);
   }

  const addToWordBank = (wordIndex) => {
    let newWordBank = [...wordBank];
    newWordBank.push(wordIndex);
    setWordBank(newWordBank);
  }

  useEffect(() => {
    if (isComplete) {
      history.go(0);
      closeModal();
    }
  }, [isComplete])

  useEffect(() => {
    setCurrentPhraseTypes(Array.apply(null, [...Array(bParagraph.split(" ").length)].map(() => "")))
  }, [])

  useEffect(() => {
    let prevProgIndex;
    if (user?.result.type === 'student') {
      prevProgIndex = user?.result.gameboardStats ? user?.result.gameboardStats.missionProgress.findIndex((mission) => mission.name === activityName) : -1;
    } else {
      prevProgIndex = -1;
    }
    
    let missionProgress = prevProgIndex >= 0 ? user?.result.gameboardStats.missionProgress[prevProgIndex] : null;
    setProgress(missionProgress !== null ? missionProgress.progressTypeSix.progress : [0, 0, 0]);
    setTries(missionProgress !== null ? missionProgress.triesTypeTwo : [0, 0, 0]);
  }, [])

  useEffect(() => {
    if (isCompleteThree === true) {
      compareAnswersThree();
      setIsCompleteThree(false);
    }
  }, [isCompleteThree])

  return (
    <div>
      <Button
        top={`10`}
        left={`1030`}
        width={40}
        height={40}
        btnFn={() => (closeModal(), history.go(0))}
        src={`/assets/gameboardPieces/planet-holo-bliss/planet-holo-bliss-close-button-2.svg`}
        alt={'comet-close-button'}
        type='close'
      />
      {
        stage === -2 ?
        <div>
          <Background
            src='/assets/gameboardPieces/comet/comet-title-screen.png'
            alt={'comet screen 1'}
          />
          <Button
            top={410}
            left={390}
            btnFn={() => setStage(stage + 1)}
            src='/assets/gameboardPieces/all-start-new-game-button.png'
            alt={'start new game'}
            type="next"
          />
          <Button
            top={502}
            left={390}
            btnFn={() => (user?.result.type === 'student' && 
                          (user?.result.gameboardStats.missionProgress.findIndex((mission) => 
                          mission.name === activityName) >= 0) ? setToCurrentProgress() : console.log('not available'))}
            src='/assets/gameboardPieces/all-continue-game-button.png'
            alt={'continue game'}
            type={`${user?.result.type === 'student' && 
                    (user?.result.gameboardStats.missionProgress.findIndex((mission) => 
                    mission.name === activityName) >= 0) ? 'continue' : 'no-continue'}`}
          />
        </div>
        : stage === -1 ?
          <div>
            <Background
              src='/assets/gameboardPieces/comet/comet-instruction-screen.png'
              alt={'comet screen 2'}
            />
            <Button
              top={653.5}
              left={880}
              width={144}
              height={49}
              btnFn={() => {setStage(stage + 1)}}
              src={`/assets/gameboardPieces/comet/comet-next-button.png`}
              alt={'comet next button'}
              type='next'
            />
            <a
              href="/pdfs/COHESIONTACTIC-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TransparentButton
                onClick={() => (console.log('cohesion comet pdf'))}
                styles={cometPdfProp}
              />
            </a>
          </div>
        : stage === 0 ?
          <div>
            <Background
              src='/assets/gameboardPieces/comet/comet-b-screen.png'
              alt={'comet screen 2'}
            />
            <p
              style={{
                position: 'absolute',
                color: 'rgb(77, 0, 38)',
                gap: '5px',
                top: '155px',
                left: '42px',
                lineHeight: '1.45',
                width: '100px',
                maxWidth: '100px',
                height: '460px',
                maxHeight: '460px'
              }}
            >
              {
                bParagraph.split(" ").map((word, index) => (
                  <>
                    <span
                      onClick={() => (wordBank.includes(index) === true ? deleteIndex(index) : addToWordBank(index))}
                      style={
                        {
                          cursor: 'pointer',
                          fontWeight: `${wordBank.includes(index) ? '700' : ''}`,
                          fontSize: `${wordBank.includes(index) ? 16 : 18}px`,
                        }
                      }
                    >
                      {word}
                    </span>
                    {
                      index === 24 || index === 45 || index === 67 || index === 94 || 
                      index === 117 || index === 134 || index === 157 || index === 182 || 
                      index === 201 || index === 221 || index === 243 || index === 266 || 
                      index === 290 || index === 309 || index === 331 || index === 352 || 
                      index === 373  ?
                      <br />
                        : <>
                          &nbsp;
                        </>
                    }
                  </>
                ))
              }
            </p>
            <Button
              top={653.5}
              left={680}
              width={184}
              height={49}
              btnFn={() => {saveAndExit()}}
              src={`/assets/gameboardPieces/comet/comet-save-and-quit-button.svg`}
              alt={'comet next button'}
              type='next'
            />
            {
              wordBank.length > 0 ?
              <Button
                top={653.5}
                left={880}
                width={144}
                height={49}
                btnFn={() => (compareAnswersOne())}
                src={`/assets/gameboardPieces/comet/comet-submit-button.svg`}
                alt={'comet next button'}
                type='next'
              />
              : null
            }
            {
              correctAmount >= 0 ?
              <>
                <EndGamePopUp
                  backgroundSrc={getResultScreen()}
                  currentPoints={correctAmount >= 1 && correctAmount <= 32 ? Math.floor((correctAmount / correctOneAnswers.length) * 100) : ""}
                  nextOnClick={() => (setStage(1), setCorrectAmount(-1))}
                  type={`comet`}
                  width={'634px'}
                  height={'434px'}
                  isCorrectTry={correctAmount === 30 && tries[0] <= 1}
                  isCorrect={correctAmount === 30}
                  tryAgainOnClick={() => (setStage(0), setWordBank([]), setCorrectAmount(-1))}
                />
              </>
              : null
            }
            <TransparentButton
              onClick={() => (setStage(10))}
              styles={wordBankProp}
            />
          </div>
        : stage === 1 ?
        <div>
          <Background
            src={`/assets/gameboardPieces/comet/comet-c-screen.png`}
            alt={'comet screen 2'}
            />
          <Button
            top={102.5}
            left={35}
            width={153}
            height={33}
            btnFn={() => {setCurrentType('assertion')}}
            src={`/assets/gameboardPieces/comet/assertion-button.png`}
            alt={'comet assertion button'}
            type={`${currentType === 'assertion' ? 'assertion-com' : 'next'}`}
          />
          <Button
            top={102.5}
            left={199}
            width={153}
            height={33}
            btnFn={() => {setCurrentType('conclusion')}}
            src={`/assets/gameboardPieces/comet/conclusion-button.png`}
            alt={'comet conclusion button'}
            type={`${currentType === 'conclusion' ? 'conclusion-com' : 'next'}`}
          />
          <Button
            top={102.5}
            left={362}
            width={200}
            height={33}
            btnFn={() => {setCurrentType('supportive')}}
            src={`/assets/gameboardPieces/comet/supportive-points-button.png`}
            alt={'comet supportive button'}
            type={`${currentType === 'supportive' ? 'supportive-com' : 'next'}`}
          />
          {
            currentType && currentType.length >= 1 && startIndex >= 0 ?
              <Button
                top={99.5}
                left={885}
                width={140}
                height={40}
                btnFn={() => (changePhraseTypes(startIndex, endIndex, currentType), setStartIndex(-1), setEndIndex(-1), setCurrentType(''))}
                src={`/assets/gameboardPieces/comet/comet-confirm-button.svg`}
                alt={'comet next button'}
                type={`next`}
              />
            : null
          }
          <p
            style={{
              position: 'absolute',
              gap: '5px',
              top: '155px',
              left: '42px',
              lineHeight: '1.45',
              width: '100px',
              maxWidth: '100px',
              height: '460px',
              maxHeight: '460px'
            }}
          >
            {
              bParagraph.split(" ").map((word, index) => (
                <>
                  <span
                    onClick={() => addDetail(index)}
                    style={
                      {
                        color: `${currentPhraseTypes[index].includes("assertion") === true || (currentType === 'assertion' && (index <= endIndex && index >= startIndex)) ? '#32CD32' : 
                                  currentPhraseTypes[index].includes("conclusion") === true || (currentType === 'conclusion' && (index <= endIndex && index >= startIndex)) ? '#f5bb72' :'rgb(77, 0, 38)'}`,
                        cursor: 'pointer',
                        fontWeight: `${currentPhraseTypes[index].length > 0 || (currentType.length >= 1 && (index <= endIndex && index >= startIndex)) ? '700' : ''}`,
                        fontSize: `${currentPhraseTypes[index].length > 0 || (currentType.length >= 1 && (index <= endIndex && index >= startIndex)) ? 16 : 18}px`,
                      }
                    }
                  >
                    {word}
                  </span>
                    {
                      index === 24 || index === 45 || index === 67 || index === 94 || 
                      index === 117 || index === 134 || index === 157 || index === 182 || 
                      index === 201 || index === 221 || index === 243 || index === 266 || 
                      index === 290 || index === 309 || index === 331 || index === 352 || 
                      index === 373  ?
                      <br />
                        : <>
                          &nbsp;
                        </>
                    }
                  </>
                ))
            }
          </p>
            <Button
              top={653.5}
              left={680}
              width={184}
              height={49}
              btnFn={() => {saveAndExit()}}
              src={`/assets/gameboardPieces/comet/comet-save-and-quit-button.svg`}
              alt={'comet next button'}
              type='next'
            />
            {
              currentType.length === 0 ?
              <Button
                top={653.5}
                left={880}
                width={144}
                height={49}
                btnFn={() => (compareAnswersTwo())}
                src={`/assets/gameboardPieces/comet/comet-submit-button.svg`}
                alt={'comet next button'}
                type='next'
              />
              : null
            }
            {
              correctAmount >= 0 ?
              <>
                <EndGamePopUp
                  backgroundSrc={getResultScreen()}
                  currentPoints={correctAmount >= 1 && correctAmount <= 4 ? correctAmount * 20
                                : ""}
                  nextOnClick={() => (setStage(stage + 1), setCorrectAmount(-1))}
                  type={`comet`}
                  width={'634px'}
                  height={'434px'}
                  isCorrectTry={correctAmount === 5 && tries[1] <= 1}
                  isCorrect={correctAmount === 5}
                  tryAgainOnClick={() => (setStage(1), setCurrentPhraseTypes(Array.apply(null, [...Array(bParagraph.split(" ").length)].map(() => ""))),
                                           setCurrentType(''), setStartIndex(-1), setEndIndex(-1), setCorrectAmount(-1))}
                />
              </>
              : null
            }
        </div>
        : stage >= 2 && stage <= 4 ?
          <div>
            <Background
              src={`/assets/gameboardPieces/comet/comet-d-${stage - 2}-screen.png`}
              alt={'comet screen 2'}
            />
            {
              [...Array(7)].map((arr, index) => (
                <Button
                  top={220.5 + (Math.floor(index / 3) * 110)}
                  left={50 + (index !== 6 ? (index % 3) * 348 : 348)}
                  width={300}
                  height={81}
                  btnFn={() => {currentList.includes(index) ? deleteWordFromCurrentList(index) :
                                currentList.length === 3 ? console.log('unavailable') : addWordToCurrentList(index)}}
                  src={`/assets/gameboardPieces/comet/supportive-detail-${stage - 2}-${index}.png`}
                  alt={'comet next button'}
                  detailCnd={currentList.includes(index)}
                  type={`${currentList.includes(index) === true ? 'comet-three' : 'next'}`}
                />
              ))
            }
            <Button
              top={653.5}
              left={680}
              width={184}
              height={49}
              btnFn={() => {saveAndExit()}}
              src={`/assets/gameboardPieces/comet/comet-save-and-quit-button.svg`}
              alt={'comet next button'}
              type='next'
            />
            {
              currentList.length === 3 ?
              <Button
                top={653.5}
                left={880}
                width={144}
                height={49}
                btnFn={() => (stage === 4 ? (addToList(currentList), setIsCompleteThree(true)): (addToList(currentList), setCurrentList([]), setStage(stage + 1)))}
                src={`/assets/gameboardPieces/comet/comet-${stage === 4 ? 'submit' : 'next'}-button.${stage === 4 ? 'svg' : 'png'}`}
                alt={'comet next button'}
                type='next'
              />
              : null
            }
            {
              correctAmount >= 0 ?
              <>
                <EndGamePopUp
                  backgroundSrc={getResultScreen()}
                  currentPoints={correctAmount >= 1 && correctAmount <= 8 ? correctAmount * 10
                                : ""}
                  nextOnClick={() => (closeModal(), history.go())}
                  type={`comet`}
                  width={'634px'}
                  height={'434px'}
                  isCorrectTry={correctAmount === 9 && tries[2] <= 1}
                  isCorrect={correctAmount === 9}
                  tryAgainOnClick={() => (setStage(2), setCurrentList([]), setCurrentLists([]), setCorrectAmount(-1))}
                />
              </>
              : null
            }
            <TransparentButton
              onClick={() => (setStage(11))}
              styles={paragraphDProp}
            />
          </div>
        : stage === 10 ?
        <div>
          <Background
            src={`/assets/gameboardPieces/comet/comet-word-bank-screen.png`}
            alt={'comet screen 2'}
          />
          <TransparentButton
            onClick={() => (setStage(0))}
            styles={paragraphProp}
          />
        </div>
        : stage === 11 ?
        <div>
          <Background
            src={`/assets/gameboardPieces/comet/comet-paragraph-screen.png`}
            alt={'comet screen 2'}
          />
          <TransparentButton
            onClick={() => (setStage(2))}
            styles={questionDProp}
          />
        </div>
        : null
      }
    </div>
  )
}

export default Comet;